import { css, jsx } from '@emotion/core';

import { bp, colors } from '@/styles';

const style = {
  hiddenTitle: css`
    display: none;
    @media ${bp.md} {
      display: block;
    }
  `,
  checkbox: css`
    .ant-checkbox {
      &-checked .ant-checkbox-inner {
        background-color: ${colors.secondaryBlue};
        border-color: ${colors.secondaryBlue};
      }
    }
  `,
  edit: css`
    font-weight: bold;
    color: ${colors.secondaryBlue};
    font-size: 1.2rem;
    &:hover {
      cursor: pointer;
      color: ${colors.primaryRed} !important;
    }
  `,
  editText: css`
    visibility: hidden;
    font-size: 1.2rem;
    @media ${bp.md} {
      visibility: visible;
    }
  `,
  row: css`
    margin-bottom: 20px;
  `,
  searchTitle: css`
    font-weight: bold;
    font-family: 'Lato', sans-serif;
    color: ${colors.primaryBlue};
    font-size: 1.6rem;
    line-height: 2.4rem;

    &:hover {
      cursor: pointer;
      color: ${colors.primaryRed};
    }
  `,
};

export default style;
